import { useQuery } from "@tanstack/react-query";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { fetchWorkspaceSummary, type ActorRole, type Workspace } from "../lib/api";
import { MvpWorkspacePages } from "./MvpWorkspacePages";

type WorkspaceSection = "overview" | "work" | "entities" | "reports" | "settings" | "users";

type WorkspaceViewProps = {
  actorRole: ActorRole;
  workspace: Workspace;
  activeSection: WorkspaceSection;
  onSectionNavigate: (path: string) => void;
};

export function WorkspaceView({ actorRole, activeSection, onSectionNavigate, workspace }: WorkspaceViewProps) {
  const { t } = useTranslation("common");
  const summaryQuery = useQuery({
    queryKey: ["workspace-summary", workspace],
    queryFn: () => fetchWorkspaceSummary(workspace)
  });

  if (summaryQuery.isLoading) {
    return <main className="workspace-main" aria-busy="true" />;
  }

  if (summaryQuery.isError || !summaryQuery.data) {
    return (
      <main className="workspace-main">
        <section className="notice notice-error">
          <AlertTriangle aria-hidden="true" size={18} />
          <span>{t("state.error")}</span>
        </section>
      </main>
    );
  }

  const summary = summaryQuery.data;
  return <MvpWorkspacePages actorRole={actorRole} activeSection={activeSection} onSectionNavigate={onSectionNavigate} summary={summary} workspace={workspace} />;
}
